<header-title [model]="headerTitle"></header-title>

<section role="main" class="">
    <section class="card mt-4">
        <header class="card-header">
            <h5 class="text-muted"><i class="fas fa-tasks"></i> New Audit</h5>
        </header>
        <div class="card-body">

            <div class="container" *ngIf="!showForm">
                <div class="row mt-5">
                    <div class="col">
                        <div class="row d-flex justify-content-center">
                            <div class="col-lg-8">
                                <div class="row mb-2">
                                    <div class="col-md-12">
                                        <div class="form-group">
                                            <label class="control-label text-primary">Which company is the Audit for</label>
                                            <select class="form-select" [(ngModel)]="cId">
                                                <option value="none" selected>Select Company</option>
                                                <option *ngFor="let c of companyList" [value]="c.id">{{c.tradingName}}</option>
                                            </select>
                                        </div>
                                    </div>
                                </div>
                                <div class="row mb-2">
                                    <div class="col-md-12">
                                        <div class="form-group text-end">
                                            <button class="btn btn-success" type="button" (click)="setCompany(cId);" [disabled]="cId=='none'">Next</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="alert alert-danger" *ngIf="showNoAuditAlert">
                <span class="fas fa-exclamation-circle"></span> No Audit Templates have been assigned to this firm
            </div>

            <form [formGroup]="addAuditFormGroup" *ngIf="showForm && addAuditFormGroup">
                <error-message [errors]="errors"></error-message>
                <div class="container">

                    <div class="row mt-5">
                        <div class="col">
                            <div class="row d-flex justify-content-center">
                                <div class="col-lg-8">


                                    <div class="row mb-2 mt-2">
                                        <div class="col-md-6 col-lg-6">
                                            <div class="form-group">
                                                <label class="control-label text-primary">Company</label>
                                                <input type="text" class="form-control" value="{{companyName}}" disabled />
                                            </div>
                                        </div>
                                        <div class="col-md-6 col-lg-6">
                                            <div class="form-group">
                                                <label class="control-label text-primary">Audit Template</label>
                                                <select name="auditTemplateId" class="form-select" formControlName="auditTemplateId" autocomplete="off"
                                                [class.border-danger]="auditTemplateId?.errors?.required && auditTemplateId?.touched">
                                                    <option value="" disabled>Please select</option>
                                                    <option *ngFor="let a of auditTemplates" [value]="a.id">{{ a.description}}</option>
                                                </select>
                                            </div>
                                            <div *ngIf="auditTemplateId?.errors?.required && auditTemplateId?.touched">
                                                <label class="control-label text-danger">
                                                    The Audit Template is required.
                                                </label>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="row mb-2">
                                        <div class="col-md-12">
                                            <div class="form-group">
                                                <label class="control-label text-primary">Title</label>
                                                <input name="title" class="form-control" formControlName="title"
                                                [class.border-danger]="title?.errors?.required && title?.touched"/>
                                            </div>
                                            <div *ngIf="title?.errors?.required && title?.touched">
                                                <label class="control-label text-danger">
                                                    A Title is required.
                                                </label>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="row mb-2">
                                        <div class="col-md-6 col-lg-6">
                                            <div class="form-group">
                                                <label class="control-label text-primary">Auditor</label>
                                                <input type="text" class="form-control" disabled value="{{selectedCompany.firstName}} {{selectedCompany.lastName}}" *ngIf="companyUsersList?.length==1" />
                                                <input type="hidden" name="auditorSiteUserId" class="form-control" formControlName="auditorSiteUserId" *ngIf="companyUsersList?.length==1" />
                                                <select name="auditorSiteUserId" class="form-select" formControlName="auditorSiteUserId" *ngIf="companyUsersList?.length>1">
                                                    <option *ngFor="let a of companyUsersList" [value]="a.siteUserId">{{a.firstName}} {{a.lastName}}</option>
                                                </select>
                                            </div>
                                        </div>
                                        <div class="col-md-2 col-lg-3">
                                            <div class="form-group">
                                                <label class="control-label text-primary">External Audit <span data-toggle="tooltip" title="If this audit is being completed by an external auditor it should be turned on to differentiate within Dashboard" class="fas fa-question-circle"></span></label>
                                                <input type="checkbox" id="isExternal" name="isExternal" class="form-control" formControlName="isExternal" appToggle />
                                            </div>
                                        </div>
                                    </div>

                                    <div class="row mb-2 mt-2">
                                        <div class="col-md-6 col-lg-6">
                                            <div class="form-group">
                                                <label class="control-label text-primary">Start Date</label>
                                                <input id="startDate"
                                                       name="startDate"
                                                       class="form-control"
                                                       formControlName="startDate"
                                                       type="text"
                                                       placeholder="DD/MM/YYYY"
                                                       bsDatepicker
                                                       [bsConfig]="{ isAnimated: true, containerClass: 'theme-default', dateInputFormat : 'DD/MM/YYYY' }"
                                                       [class.border-danger]="startDate?.errors?.required && startDate?.touched">
                                            </div>
                                            <div *ngIf="startDate?.errors?.required && startDate?.touched">
                                                <label class="control-label text-danger">
                                                    The Start Date is required.
                                                </label>
                                            </div>
                                        </div>
                                        <div class="col-md-6 col-lg-6">
                                            <div class="form-group">
                                                <label class="control-label text-primary">Deadline Date</label>
                                                <input id="deadlineDate"
                                                       name="deadlineDate"
                                                       class="form-control"
                                                       formControlName="deadlineDate"
                                                       type="text"
                                                       placeholder="DD/MM/YYYY"
                                                       bsDatepicker
                                                       [minDate]="addAuditFormGroup.value.startDate"
                                                       [bsConfig]="{ isAnimated: true, containerClass: 'theme-default', dateInputFormat : 'DD/MM/YYYY' }"
                                                       [class.border-danger]="deadlineDate?.value && (deadlineDate?.value < startDate.value)">
                                            </div>
                                            <div *ngIf="deadlineDate?.value && (deadlineDate?.value < startDate.value)">
                                                <label class="control-label text-danger">
                                                    The Deadline must be after the start date.
                                                </label>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="row mb-2 mt-2" *ngIf="addAuditFormGroup.value.auditorSiteUserId != user.id">
                                        <div class="col-12">
                                            <div class="form-group">
                                                <label class="control-label text-warning">You have assigned this Audit to another User. Please enter a message for the email that will be sent to alert that User.</label>
                                                <textarea id="emailMessage" name="emailMessage" class="form-control" formControlName="emailMessage" placeholder="E.g. Please add a minimum of 6 file audits from the last financial quarter."></textarea>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="container">
                    <div class="row my-5">
                        <div class="col">
                            <div class="container">
                                <div class="row">
                                    <div class="col-6">
                                        <button class="btn btn-outline-primary" type="button" (click)="unSetCompany();">Back</button>
                                    </div>
                                    <div class="col-6 text-end">
                                        <button class="btn btn-success" type="button" (click)="createAudit();">Create Audit</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </form>
        </div>
    </section>

</section>
